<template>
    <div id="secretadminconfigpage">
        <div class="container admin-wrap">
            <div class="row">
                <div class="col-lg-12">
                    <label>Action</label>
                </div>
                <div class="col-lg-12">
                    <el-select v-model="selectedAction" placeholder="Select Action" @change="SelectAction()" style="width:100%;">
                        <el-option v-for="item in actionList" 
                                :key="item" 
                                :label="item" 
                                :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="row" v-if="selectedAction !== ''" style="margin-top:20px;">
                <div class="col-lg-12">
                    <label>Secret Key</label>
                </div>
                <div class="col-lg-12">
                    <input type="text" class="form-control form__input" v-model="secretKey">
                </div>
            </div>
            <div class="row" v-if="selectedAction == 'Change Parent Login Email'" style="margin-top:20px;">
                <div class="col-lg-12">
                    <label>From Email</label>
                </div>
                <div class="col-lg-12">
                    <input type="text" class="form-control form__input" v-model="fromEmail">
                </div>
                <div class="col-lg-12">
                    <label>To Email</label>
                </div>
                <div class="col-lg-12">
                    <input type="text" class="form-control form__input" v-model="toEmail">
                </div>
                <div class="col-lg-12">
                     <el-button type="primary" v-on:click="submitChangeParentEmail()">Submit</el-button>
                </div>
            </div>
            <div class="row" v-if="result !== ''" style="margin-top:20px;">
                <div class="col-lg-12">
                    <label>Result : {{result}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";

    export default {
        name: "SecretAdminConfigPage",
        data() {
            return {
                actionList:['Change Parent Login Email'],
                selectedAction: '',
                result: '',
                secretKey: '',
                fromEmail: '',
                toEmail: '',
            };
        },
        async created() {
            
        },
        methods: {
            SelectAction() {
                try {
                    this.clearData();
                } catch (e) {
                    this.results = e;
                }
            },
            clearData() {
                try {
                    this.result = '';
                    this.secretKey = '';
                    this.fromEmail = '';
                    this.toEmail = '';
                } catch (e) {
                    this.results = e;
                }
            },
            async submitChangeParentEmail() {
                try {
                    this.result = '';

                    if (this.secretKey === '' || this.fromEmail === '' || this.toEmail === '') {
                        this.result = 'Please fill all information!';
                    } else {
                        this.$vs.loading();

                        const response = await DataSource.shared.changeParentEmail(this.secretKey, this.fromEmail, this.toEmail);
                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                this.result = 'Error 99';
                            } else if (response.code === '2') {
                                this.result = 'Invalid Secret Key!';
                            } else if (response.code === '3') {
                                this.result = 'From Email Not Existing!';
                            } else if (response.code === '4') {
                                this.result = 'To Email Existing!';
                            } else if (response.code === '1') {
                                this.result = 'Successfully Change!';
                            }
                        }

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
        },
    }
</script>

<style scoped>

</style>